module.exports = "/assets/139616db7555c7989f2ab63323f855f6.png";